var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((3),function(n){return _c('div',{key:n,staticClass:"advertisement"},[_vm._v(" Advertentie "+_vm._s(n)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }